export default "__VITE_ASSET__4X9mHs4Y__"